import React from "react"

import { TypeAnimation } from "react-type-animation"

type Props = {
  text: string
  onDone: () => void
}

export default function BotMessage({ text, onDone }: Props) {
  return (
    <div className="bubble bot">
      <TypeAnimation sequence={[text, 300, onDone]} speed={40} cursor={false} />
    </div>
  )
}
